export default __webpack_public_path__ + "static/media/ISKO_CLASS-10_SYLLABUS.52f1dd5e.pdf";